import React from 'react';
import { Link } from 'react-router-dom';
import Coupon from './Coupon';

const ListCoupons = props => {
  const { coupons, deleteCoupon } = props.couponInfo;
  const { mode } = props;

  const getCoupon = () => {
    return coupons.map(coupon => {
      const couponInfo = { deleteCoupon, coupon };
      return <Coupon mode={mode} couponInfo={couponInfo} key={coupon.id} />;
    });
  };
  return (
    <div className="box">
      <div className="box-header with-border">
        <h3 className="box-title">Coupons</h3>
        {mode === 'edit' && (
          <Link className="cus-btn-primary pull-right" to="/coupon/create">
            Add Coupon
          </Link>
        )}
      </div>
      <div className="box-body">
        <table className="table table-bordered table-responsive table-hover">
          <thead>
            <tr>
              <th>Code</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Valid</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>{getCoupon()}</tbody>
        </table>
      </div>
    </div>
  );
};

export default ListCoupons;
